import React from "react";
import { isApplePayAvailable } from './../Core/PaymentUtils';

const Payments = ({ selectedId, payments, enablePayments, onChange, onSubmit }) => {
	var T = window.Texts.checkout;
	var filteredPayments = payments.filter(p => {
		if (p.gateway === "gopay_ap" && !isApplePayAvailable()) {
			return false;
		}
		return true;
	});

	return (
		<div className="box form-box payment-methods">
			<h2>{T.payment}</h2>
			<ul>
				{filteredPayments.map((payment) => {
					return ((enablePayments.indexOf(payment.id) > -1) ?
						<li key={'payment' +  payment.id}>
							<label className={(payment.id == selectedId) ? 'active' : ''}>
								<input value={payment.id} name="OrderPaymentMethod" type="radio" checked={payment.id == selectedId} onChange={(e)=>onChange(e)}/>
								{payment.name}
								{(window.Config.mode == 'liveua' && payment.paidUponReceipt) ?
								<div className="xo-labelInside tarif">{(payment.priceTable.totalPriceInclVat > 0) ? payment.priceTable.displayTotalPriceInclVat : T.tarif}</div> :
														<div className="xo-labelInside">
										{(payment.priceTable.totalPriceInclVat > 0) ? payment.priceTable.displayTotalPriceInclVat : T.free}</div>}
								<div style={{ clear: 'both' }} />
							</label>
							{(payment.gateway == "homecred" && payment.id == selectedId && T.homeCreditNote) ? <small style={{ fontSize:'small' }} dangerouslySetInnerHTML={{ __html: T.homeCreditNote }} /> : null}
						</li> : null);
				}
				)}
			</ul>
			<div className="payment-submit">
				<button onClick={(e) => onSubmit(e)} className="btn btn50 iconed icon-continue"><span>{T.continue_}</span></button>
				{T.paymentNote ?
					<div className="payment-note">{T.paymentNote}</div> : null}
			</div>
		</div>

	);
};

export default Payments;